<template>
    <div class="builder-sidebar-segment">
        <slot></slot>
    </div>
</template>
